'use strict';

var $ = global.jQuery;
var root = $('html');

function getYouTubeId(url) {
	url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
	return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : false;
}

// Handlers
function handleOpen(e) {
	e.preventDefault();

	// Add class to root
	root.addClass('modal-view');

	var href = $(this).attr('href');

	// Check for YouTube link
	var youTubeId = getYouTubeId(href)

	if ( youTubeId ) {
		var url = 'https://www.youtube.com/embed/' + youTubeId + '?autoplay=1';
		$('.modal-content').html('<div class="responsive-video"><iframe width="100%" height="100%" src="' + url + '"></iframe></div>');
	} else if ( /^#/.test(href) ) {
		$('.modal-content').html('<div class="modal-content__inline">' + $(href).html() + '</div>');
	} else {
		$('.modal-content').html('<iframe width="100%" height="100%" src="' + href + '"></iframe>');
	}
}

function handleClose(e) {
	e.preventDefault();

	// Clean up
	root.removeClass('modal-view');
	$('.modal-content').empty();
}

// Events
$('[data-modal]').on('click', handleOpen);
$('.modal').on('click', function(e) {
	this === e.target && handleClose(e)
});
$('.modal-close').on('click', handleClose);